import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { formatText } from '../../helpers/value'
import classes from '../index.module.scss'

export const HeaderPanel = ({ contentLeft, contentRight, isI18n, style }) => {
  return (
    <Element
      className={classes.headerPanelCommon}
      style={{
        backgroundColor: '#D5D5D5',
        ...style,
      }}
    >
      <Element elementName="p" style={{ fontSize: 14 }}>
        {isI18n ? <Translate value={contentLeft} /> : formatText(contentLeft)}
      </Element>
      {contentRight && (
        <Element elementName="p" style={{ fontSize: 14 }}>
          {formatText(contentRight)}
        </Element>
      )}
    </Element>
  )
}

HeaderPanel.propTypes = {
  contentLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  contentRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  isI18n: PropTypes.bool,
}
HeaderPanel.defaultProps = {
  style: {},
  isI18n: false,
}
